import React from 'react';
import styled from 'styled-components';

import { LayoutColors } from '@src/core/theme';
import useTranslate from '@src/i18n/useTranslate';
import { OrderStatus } from '@src/core/buyerApiClient';
import { BodySmall } from '@src/fonts/typography/Typography';
import { getConvertedOrderStatusType } from '@src/common/order';

type Props = {
  status: OrderStatus;
};

const OrderStatusDisplay = ({ status }: Props) => {
  const { i18nElement } = useTranslate();
  const { background } = getConvertedOrderStatusType(status);

  return <Container style={{ background }}>{i18nElement(status)}</Container>;
};

export default OrderStatusDisplay;

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  background: ${LayoutColors.successDark};
  border-radius: 8px;

  ${BodySmall};
  color: ${LayoutColors.whiteLight};
  padding: 4px 8px;
`;
